import React, { Component } from 'react';
import "../../../css/general-style.css";
import '../../../css/table-responsive.css';
import "../../../css/dashboard.css";
import styles from '../../../css/AddNewProduct.module.css';
import LoadingWindow from '../../../components/LoadingWindow';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { RiArrowGoBackFill } from 'react-icons/ri';
import { MdPhotoCamera } from 'react-icons/md';
import { BsPlusCircle, BsXCircle } from 'react-icons/bs';
import { TbStack2, TbTruck } from 'react-icons/tb';
import { getValueCookie } from '../../../services/cookieService';
import { getInformationWithData } from '../../../services/CABE';
import { getNextProductLine, getNextVendorNo } from '../../../services/maintenanceService';
import { validateProductLine, emptyProductLineForm } from '../../Maintenance/ProductLines';
import { validateVendor, emptyVendorForm, formatPhone, phoneDigits } from '../../Maintenance/Vendors';
import { Menu } from "../../../components/Menu/Menu";

const VENDOR_FIELDS = [
    { id: 'VendorName',   label: 'Vendor Name',   col: 'col-12' },
    { id: 'AddressLine1', label: 'Address Line 1', col: 'col-12' },
    { id: 'City',         label: 'City',           col: 'col-6' },
    { id: 'State',        label: 'State',          col: 'col-3' },
    { id: 'ZipCode',      label: 'Zip Code',       col: 'col-3' },
    { id: 'TelephoneNo',  label: 'Telephone No',   col: 'col-6', type: 'tel', kind: 'phone', placeholder: '+1 (555) 123-4567' },
    { id: 'EmailAddress', label: 'Email Address',  col: 'col-6', type: 'email' },
];

export default class AddNewProduct extends Component {
    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }

    state = {
        step: 1,

        // Step 1 — Product Line
        ProductLineList: [],
        selectedProductLine: null,
        plStepError: '',
        showPLModal: false,
        plForm: emptyProductLineForm(),
        plErrors: {},
        plSaving: false,
        plLoading: false,

        // Step 2 — Vendor
        VendorList: [],
        selectedVendor: null,
        vendorStepError: '',
        showVendorModal: false,
        vendorForm: emptyVendorForm(),
        vendorErrors: {},
        vendorSaving: false,
        vendorLoading: false,

        // Step 3 — Product fields
        productName: '',
        itemCode: '',
        upc: '',
        upc2: '',
        caseUpc: '',
        um: '',
        weight: '',
        length: '',
        height: '',
        width: '',
        initialStock: '',
        costPrice: '',
        preSale: false,
        formSubmitting: false,
    };

    async componentDidMount() {
        this.ModalLoading.current.showState(true);
        await Promise.all([this.loadProductLines(), this.loadVendors()]);
        this.ModalLoading.current.showState(false);
    }

    async loadProductLines() {
        const response = await getInformationWithData('/Items/get-exception-items');
        const data = (response && response.data && response.data.data) || [];
        this.setState({
            ProductLineList: data.map(pl => ({
                value: pl.ProductLine || pl.productLine || '',
                label: pl.ProductLineDesc || pl.productLineDesc || '',
                markup: pl.DiscountMarkup != null ? pl.DiscountMarkup : (pl.markup != null ? pl.markup : ''),
            })),
        });
    }

    async loadVendors() {
        const response = await getInformationWithData('/vendors/get/vendorsInformation', { idCompany: getValueCookie('CompanyId') });
        const data = Array.isArray(response && response.data) ? response.data : [];
        this.setState({
            VendorList: data.map(v => ({
                value: v.VendorNo || v.vendorNo || v.customerNo || '',
                label: v.VendorName || v.name || '',
            })),
        });
    }

    // ── Step navigation ──────────────────────────────────────────────────────

    goToStep2 = () => {
        if (!this.state.selectedProductLine) {
            this.setState({ plStepError: 'Please select a product line before continuing.' });
            return;
        }
        this.setState({ step: 2, plStepError: '' });
    };

    goToStep3 = () => {
        if (!this.state.selectedVendor) {
            this.setState({ vendorStepError: 'Please select a vendor before continuing.' });
            return;
        }
        this.setState({ step: 3, vendorStepError: '' });
    };

    goBack = () => this.setState(prev => ({ step: prev.step - 1 }));

    // ── Product Line modal ───────────────────────────────────────────────────

    openPLModal = async () => {
        this.setState({ plLoading: true });
        const nextNo = await getNextProductLine();
        this.setState({
            plLoading: false,
            showPLModal: true,
            plForm: { ...emptyProductLineForm(), productLine: nextNo || '' },
            plErrors: {},
        });
    };

    closePLModal = () => this.setState({ showPLModal: false });

    onPLField = (key, value) => {
        this.setState(prev => ({
            plForm: { ...prev.plForm, [key]: value },
            plErrors: { ...prev.plErrors, [key]: undefined },
        }));
    };

    submitPL = async () => {
        const { plForm } = this.state;
        const errors = validateProductLine(plForm);
        if (Object.keys(errors).length > 0) { this.setState({ plErrors: errors }); return; }
        this.setState({ plSaving: true });
        // TODO: backend endpoint POST /my/product-line/create
        const res = await getInformationWithData('/my/product-line/create', {
            ...plForm,
            markup: Number(plForm.markup),
            idCompany: getValueCookie('CompanyId'),
            updateBy: getValueCookie('userName'),
        });
        this.setState({ plSaving: false });
        if (res && res.status && res.status.code === 1) {
            Swal.fire({ icon: 'success', title: 'Product line created', timer: 1500, showConfirmButton: false });
            const newOpt = { value: plForm.productLine, label: plForm.productLineDesc, markup: plForm.markup };
            await this.loadProductLines();
            this.setState({ showPLModal: false, selectedProductLine: newOpt, plStepError: '' });
        } else {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Could not create product line. Please try again.' });
        }
    };

    // ── Vendor modal ─────────────────────────────────────────────────────────

    openVendorModal = async () => {
        this.setState({ vendorLoading: true });
        const nextNo = await getNextVendorNo();
        this.setState({
            vendorLoading: false,
            showVendorModal: true,
            vendorForm: { ...emptyVendorForm(), VendorNo: nextNo || '' },
            vendorErrors: {},
        });
    };

    closeVendorModal = () => this.setState({ showVendorModal: false });

    onVendorField = (id, value) => {
        this.setState(prev => ({
            vendorForm: { ...prev.vendorForm, [id]: value },
            vendorErrors: { ...prev.vendorErrors, [id]: undefined },
        }));
    };

    submitVendor = async () => {
        const { vendorForm } = this.state;
        const errors = validateVendor(vendorForm);
        if (Object.keys(errors).length > 0) { this.setState({ vendorErrors: errors }); return; }
        const payload = { ...vendorForm, TelephoneNo: phoneDigits(vendorForm.TelephoneNo) };
        this.setState({ vendorSaving: true });
        // TODO: backend endpoint POST /my/vendors/new
        const res = await getInformationWithData('/my/vendors/new', {
            ...payload,
            idCompany: getValueCookie('CompanyId'),
            updateBy: getValueCookie('userName'),
        });
        this.setState({ vendorSaving: false });
        if (res && res.status && res.status.code === 1) {
            Swal.fire({ icon: 'success', title: 'Vendor created', timer: 1500, showConfirmButton: false });
            const newOpt = { value: vendorForm.VendorNo, label: vendorForm.VendorName };
            await this.loadVendors();
            this.setState({ showVendorModal: false, selectedVendor: newOpt, vendorStepError: '' });
        } else {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Could not create vendor. Please try again.' });
        }
    };

    // ── Product form ─────────────────────────────────────────────────────────

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState({ [name]: type === 'checkbox' ? checked : value });
    };

    hasLetters = (str) => /[a-zA-Z]/.test(str);

    submitProduct = async (e) => {
        e.preventDefault();
        const { upc, caseUpc, itemCode, productName, upc2, um, weight, length, height, width, initialStock, costPrice, preSale, selectedProductLine, selectedVendor } = this.state;

        if (this.hasLetters(upc) || this.hasLetters(caseUpc)) {
            Swal.fire({ title: 'Invalid UPC values', text: 'UPC fields must contain numbers only.', icon: 'warning', confirmButtonColor: '#2563EB' });
            return;
        }

        const responseCheck = await getInformationWithData('/v2/items/exists', { data: { upc, itemCode } });
        const { upc_exists, item_code_exists } = (responseCheck && responseCheck.data) || {};
        if (upc_exists > 0 || item_code_exists > 0) {
            Swal.fire({ title: 'Item Code or UPC Already Exists', text: 'Both the Item Code and the UPC must be unique.', icon: 'warning', confirmButtonColor: '#2563EB' });
            return;
        }

        this.setState({ formSubmitting: true });
        // TODO: backend endpoint POST /v2/items/create
        const res = await getInformationWithData('/v2/items/create', {
            productName, itemCode, upc, upc2, caseUpc, um,
            weight: Number(weight), length: Number(length), height: Number(height), width: Number(width),
            initialStock: Number(initialStock) || 0,
            costPrice: Number(costPrice) || 0,
            preSale: preSale ? 1 : 0,
            productLine: selectedProductLine.value,
            vendorNo: selectedVendor.value,
            idCompany: getValueCookie('CompanyId'),
        });
        this.setState({ formSubmitting: false });
        if (res && res.status && res.status.code === 1) {
            Swal.fire({ icon: 'success', title: 'Product created successfully!', confirmButtonColor: '#2563EB' })
                .then(() => { window.location.href = '/inventory/products'; });
        } else {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Could not create the product. Please try again.', confirmButtonColor: '#2563EB' });
        }
    };

    // ── Shared select style ──────────────────────────────────────────────────

    selectStyle = {
        control: (base, state) => ({
            ...base,
            borderRadius: '10px',
            border: state.isFocused ? '1.5px solid #2563EB' : '1px solid #E2E8F0',
            boxShadow: state.isFocused ? '0 0 0 3px rgba(37,99,235,0.1)' : 'none',
            fontSize: '1rem',
            minHeight: '44px',
        }),
    };

    // ── Render helpers ────────────────────────────────────────────────────────

    renderStepper() {
        const { step } = this.state;
        const steps = ['Product Line', 'Vendor', 'Product Details'];
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '2rem' }}>
                {steps.map((label, idx) => {
                    const n = idx + 1;
                    const done = n < step;
                    const active = n === step;
                    return (
                        <React.Fragment key={n}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.4rem' }}>
                                <div style={{
                                    width: 40, height: 40, borderRadius: '50%',
                                    background: done ? '#10b981' : active ? '#2563EB' : '#E2E8F0',
                                    color: done || active ? 'white' : '#64748B',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontWeight: 700, fontSize: '0.9rem', transition: 'all 0.3s',
                                }}>
                                    {done ? '✓' : n}
                                </div>
                                <span style={{
                                    fontSize: '0.75rem', whiteSpace: 'nowrap',
                                    fontWeight: active ? 700 : 500,
                                    color: active ? '#2563EB' : done ? '#10b981' : '#94A3B8',
                                }}>
                                    {label}
                                </span>
                            </div>
                            {idx < steps.length - 1 && (
                                <div style={{
                                    flex: 1, height: 2, minWidth: 40, margin: '0 8px', marginBottom: '1.5rem',
                                    background: n < step ? '#10b981' : '#E2E8F0', transition: 'background 0.3s',
                                }} />
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }

    renderSelectedBadge(fields) {
        return (
            <div style={{ background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: '10px', padding: '1rem', marginTop: '1rem', display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
                {fields.map(([lbl, val]) => val !== undefined && val !== '' && (
                    <div key={lbl}>
                        <div style={{ fontSize: '0.75rem', color: '#64748B', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{lbl}</div>
                        <div style={{ fontWeight: 700, color: '#1e40af', marginTop: '0.2rem' }}>{val}</div>
                    </div>
                ))}
            </div>
        );
    }

    renderStep1() {
        const { ProductLineList, selectedProductLine, plStepError, plLoading } = this.state;
        return (
            <div className={`${styles.cardModern} ${styles.fadeIn}`}>
                <div className={styles.cardHeaderCustom}>
                    <h3 className={styles.cardTitle}>
                        <TbStack2 style={{ marginRight: '0.5rem', verticalAlign: 'middle' }} />
                        Select Product Line
                    </h3>
                </div>
                <div className={styles.cardBodyCustom}>
                    <p style={{ color: '#64748B', marginBottom: '1.5rem' }}>
                        Choose the product line this item belongs to. The product line determines the item code prefix and pricing markup.
                    </p>
                    <div className={styles.formGroup}>
                        <label className={styles.formLabel}>
                            Product Line <span className={styles.requiredIndicator}>*</span>
                        </label>
                        <Select
                            isSearchable
                            styles={this.selectStyle}
                            placeholder="Search product lines…"
                            value={selectedProductLine}
                            onChange={opt => this.setState({ selectedProductLine: opt, plStepError: '' })}
                            options={ProductLineList}
                        />
                        {plStepError && (
                            <p style={{ color: '#EF4444', fontSize: '0.875rem', margin: '0.5rem 0 0' }}>{plStepError}</p>
                        )}
                    </div>

                    {selectedProductLine && this.renderSelectedBadge([
                        ['Code', selectedProductLine.value],
                        ['Description', selectedProductLine.label],
                        ['Markup', selectedProductLine.markup !== '' ? `${selectedProductLine.markup}%` : undefined],
                    ])}

                    <div style={{ borderTop: '1px solid #E2E8F0', marginTop: '1.5rem', paddingTop: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
                        <p style={{ margin: 0, color: '#64748B', fontSize: '0.9rem' }}>
                            Don't see the product line you need?
                        </p>
                        <button
                            type="button"
                            onClick={this.openPLModal}
                            disabled={plLoading}
                            style={{
                                background: 'white', border: '1.5px solid #2563EB', borderRadius: '10px',
                                color: '#2563EB', padding: '0.6rem 1.25rem', fontWeight: 600, fontSize: '0.875rem',
                                cursor: plLoading ? 'not-allowed' : 'pointer', opacity: plLoading ? 0.7 : 1,
                                display: 'flex', alignItems: 'center', gap: '0.4rem',
                            }}
                        >
                            <BsPlusCircle /> {plLoading ? 'Loading…' : 'Create Product Line'}
                        </button>
                    </div>
                </div>
                <div className={styles.bottomActionBar}>
                    <a href="/inventory/products" className={`${styles.actionBtn} ${styles.btnSecondaryCustom}`} style={{ textDecoration: 'none', minWidth: 120 }}>
                        <RiArrowGoBackFill /> Cancel
                    </a>
                    <button type="button" className={styles.btnSaveCustom} onClick={this.goToStep2}>
                        Next: Select Vendor →
                    </button>
                </div>
            </div>
        );
    }

    renderStep2() {
        const { VendorList, selectedVendor, vendorStepError, vendorLoading } = this.state;
        return (
            <div className={`${styles.cardModern} ${styles.fadeIn}`}>
                <div className={styles.cardHeaderCustom}>
                    <h3 className={styles.cardTitle}>
                        <TbTruck style={{ marginRight: '0.5rem', verticalAlign: 'middle' }} />
                        Select Vendor
                    </h3>
                </div>
                <div className={styles.cardBodyCustom}>
                    <p style={{ color: '#64748B', marginBottom: '1.5rem' }}>
                        Choose the primary vendor that supplies this product.
                    </p>
                    <div className={styles.formGroup}>
                        <label className={styles.formLabel}>
                            Vendor <span className={styles.requiredIndicator}>*</span>
                        </label>
                        <Select
                            isSearchable
                            styles={this.selectStyle}
                            placeholder="Search vendors…"
                            value={selectedVendor}
                            onChange={opt => this.setState({ selectedVendor: opt, vendorStepError: '' })}
                            options={VendorList}
                        />
                        {vendorStepError && (
                            <p style={{ color: '#EF4444', fontSize: '0.875rem', margin: '0.5rem 0 0' }}>{vendorStepError}</p>
                        )}
                    </div>

                    {selectedVendor && this.renderSelectedBadge([
                        ['Vendor No', selectedVendor.value],
                        ['Vendor Name', selectedVendor.label],
                    ])}

                    <div style={{ borderTop: '1px solid #E2E8F0', marginTop: '1.5rem', paddingTop: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
                        <p style={{ margin: 0, color: '#64748B', fontSize: '0.9rem' }}>
                            Don't see your vendor?
                        </p>
                        <button
                            type="button"
                            onClick={this.openVendorModal}
                            disabled={vendorLoading}
                            style={{
                                background: 'white', border: '1.5px solid #2563EB', borderRadius: '10px',
                                color: '#2563EB', padding: '0.6rem 1.25rem', fontWeight: 600, fontSize: '0.875rem',
                                cursor: vendorLoading ? 'not-allowed' : 'pointer', opacity: vendorLoading ? 0.7 : 1,
                                display: 'flex', alignItems: 'center', gap: '0.4rem',
                            }}
                        >
                            <BsPlusCircle /> {vendorLoading ? 'Loading…' : 'Create Vendor'}
                        </button>
                    </div>
                </div>
                <div className={styles.bottomActionBar}>
                    <button type="button" className={`${styles.actionBtn} ${styles.btnSecondaryCustom}`} onClick={this.goBack} style={{ minWidth: 120 }}>
                        ← Back
                    </button>
                    <button type="button" className={styles.btnSaveCustom} onClick={this.goToStep3}>
                        Next: Product Details →
                    </button>
                </div>
            </div>
        );
    }

    renderStep3() {
        const { selectedProductLine, selectedVendor, formSubmitting } = this.state;
        return (
            <form onSubmit={this.submitProduct}>
                <div className="row g-4">

                    {/* Left: Image upload */}
                    <div className="col-lg-3">
                        <div className={`${styles.cardModern} ${styles.fadeIn}`}>
                            <div className={styles.cardHeaderCustom}>
                                <h3 className={styles.cardTitle}>Product Image</h3>
                            </div>
                            <div className={styles.cardBodyCustom}>
                                <div className={styles.imageContainer}>
                                    <img src="" alt="New Product" id="createProductImg" style={{ display: 'none' }} />
                                    <div className={styles.uploadPlaceholder} id="createPlaceholder">
                                        <div className={styles.uploadIcon}><MdPhotoCamera /></div>
                                        <p style={{ margin: 0, fontWeight: 500 }}>Click to upload</p>
                                        <p style={{ margin: 0, fontSize: '0.875rem' }}>PNG, JPG up to 10MB</p>
                                    </div>
                                    <button className={styles.changeBtn} type="button">Upload Image</button>
                                </div>
                                <input type="file" id="createFileInput" style={{ display: 'none' }} accept="image/*" />
                                <p className={styles.formHelpText} style={{ marginTop: '1rem' }}>
                                    Recommended: Square image, min 800×800px
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Right: Form fields */}
                    <div className="col-lg-9">
                        <div className={`${styles.cardModern} ${styles.fadeIn}`}>
                            <div className={styles.cardHeaderCustom} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h3 className={styles.cardTitle}>Product Details</h3>
                                <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748B' }}>
                                    <span className={styles.requiredIndicator} style={{ fontWeight: 'bold' }}>*</span> Required Fields
                                </p>
                            </div>
                            <div className={styles.cardBodyCustom}>

                                {/* Identity */}
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Product Name <span className={styles.requiredIndicator}>*</span></label>
                                            <input type="text" name="productName" className={styles.formInput} placeholder="Full product name" required onChange={this.handleChange} />
                                            <p className={styles.formHelpText}>Clear, descriptive name</p>
                                        </div>
                                    </div>
                                    <div className={`col-md-6 ${styles.formCenter}`}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.9375rem', fontWeight: 500, color: '#334155' }}>
                                            <input type="checkbox" name="preSale" onChange={this.handleChange} style={{ width: '16px', height: '16px', accentColor: '#2563EB' }} />
                                            Pre-Sale Product
                                        </label>
                                    </div>
                                </div>

                                <hr className={styles.sectionDivider} />
                                <h4 className={styles.sectionTitle}>Classification</h4>

                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Item Code <span className={styles.requiredIndicator}>*</span></label>
                                            <input type="text" name="itemCode" className={styles.formInput} placeholder="e.g. FOOD-001" required onChange={this.handleChange} />
                                            <p className={styles.formHelpText}>Must include the product line prefix</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Product Line <span className={styles.requiredIndicator}>*</span></label>
                                            <input
                                                type="text"
                                                className={styles.formInput}
                                                value={selectedProductLine ? `${selectedProductLine.value} — ${selectedProductLine.label}` : ''}
                                                readOnly
                                                style={{ background: '#F1F5F9', color: '#64748B', cursor: 'not-allowed' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Primary Vendor <span className={styles.requiredIndicator}>*</span></label>
                                            <input
                                                type="text"
                                                className={styles.formInput}
                                                value={selectedVendor ? `${selectedVendor.value} — ${selectedVendor.label}` : ''}
                                                readOnly
                                                style={{ background: '#F1F5F9', color: '#64748B', cursor: 'not-allowed' }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <hr className={styles.sectionDivider} />
                                <h4 className={styles.sectionTitle}>Barcodes</h4>

                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>UPC <span className={styles.requiredIndicator}>*</span></label>
                                            <input type="text" name="upc" className={styles.formInput} placeholder="012345678901" required onChange={this.handleChange} />
                                            <p className={styles.formHelpText}>Primary barcode — numbers only</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>UPC 2 <span style={{ color: '#94A3B8', fontWeight: 400, fontSize: '0.75rem' }}>(optional)</span></label>
                                            <input type="text" name="upc2" className={styles.formInput} placeholder="098765432109" onChange={this.handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Case UPC <span className={styles.requiredIndicator}>*</span></label>
                                            <input type="text" name="caseUpc" className={styles.formInput} placeholder="112233445566" required onChange={this.handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Unit of Measure</label>
                                            <input type="text" name="um" className={styles.formInput} placeholder="e.g. EA, CS, LB" onChange={this.handleChange} />
                                        </div>
                                    </div>
                                </div>

                                <hr className={styles.sectionDivider} />
                                <h4 className={styles.sectionTitle}>Physical Dimensions</h4>

                                <div className="row g-3">
                                    {[
                                        { name: 'weight', label: 'Weight', unit: 'lbs' },
                                        { name: 'length', label: 'Length', unit: 'in' },
                                        { name: 'height', label: 'Height', unit: 'in' },
                                        { name: 'width',  label: 'Width',  unit: 'in' },
                                    ].map(f => (
                                        <div key={f.name} className="col-md-6">
                                            <div className={styles.formGroup}>
                                                <label className={styles.formLabel}>
                                                    {f.label} <span className={styles.requiredIndicator}>*</span>
                                                </label>
                                                <div className={styles.formInputGroup}>
                                                    <input
                                                        type="number" name={f.name} className={styles.formInput}
                                                        placeholder="0.0" step="0.1" min="0" required
                                                        onChange={this.handleChange} onWheel={e => e.target.blur()}
                                                    />
                                                    <span className={styles.inputUnit}>{f.unit}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <hr className={styles.sectionDivider} />
                                <h4 className={styles.sectionTitle}>Inventory &amp; Pricing</h4>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Initial Stock</label>
                                            <input type="number" name="initialStock" className={styles.formInput} placeholder="0" min="0" onChange={this.handleChange} />
                                            <p className={styles.formHelpText}>Starting quantity on hand</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Cost Price</label>
                                            <div className={styles.formInputGroup}>
                                                <span className={styles.inputUnit} style={{ marginLeft: 0, marginRight: '0.05rem' }}>$</span>
                                                <input type="number" name="costPrice" className={styles.formInput} placeholder="0.00" step="0.01" min="0" onChange={this.handleChange} onWheel={e => e.target.blur()} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* Sticky action bar */}
                        <div className={styles.bottomActionBar}>
                            <button type="button" className={`${styles.actionBtn} ${styles.btnSecondaryCustom}`} onClick={this.goBack} style={{ minWidth: 120 }}>
                                ← Back
                            </button>
                            <div className={styles.btnGroup}>
                                <a href="/inventory/products" className={`${styles.actionBtn} ${styles.btnSecondaryCustom}`} style={{ textDecoration: 'none' }}>
                                    Cancel
                                </a>
                                <button type="submit" className={styles.btnSaveCustom} disabled={formSubmitting}>
                                    {formSubmitting ? 'Creating…' : 'Create Product'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }

    renderPLModal() {
        const { showPLModal, plForm, plErrors, plSaving } = this.state;
        if (!showPLModal) return null;
        return (
            <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 }}>
                <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '480px', margin: '1rem', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', borderRadius: '16px 16px 0 0', padding: '1.5rem 2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            <div style={{ color: 'white', fontFamily: "'Archivo', sans-serif", fontWeight: 700, fontSize: '1.125rem' }}>Create New Product Line</div>
                            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem', marginTop: '0.25rem' }}>Product Line No is assigned by the system</div>
                        </div>
                        <button onClick={this.closePLModal} style={{ background: 'none', border: 'none', color: 'white', fontSize: '1.25rem', cursor: 'pointer' }}><BsXCircle /></button>
                    </div>
                    <div style={{ padding: '1.5rem 2rem' }}>
                        <div className="row g-3">
                            <div className="col-12">
                                <label className={styles.formLabel}>Product Line No (system)</label>
                                <input className={styles.formInput} value={plForm.productLine || ''} disabled style={{ background: '#F1F5F9', color: '#64748B' }} placeholder="Assigned by the system" />
                            </div>
                            <div className="col-12">
                                <label className={styles.formLabel}>Description <span className={styles.requiredIndicator}>*</span></label>
                                <input
                                    className={styles.formInput}
                                    style={plErrors.productLineDesc ? { borderColor: '#EF4444' } : {}}
                                    value={plForm.productLineDesc || ''}
                                    onChange={e => this.onPLField('productLineDesc', e.target.value)}
                                    placeholder="Product line description"
                                />
                                {plErrors.productLineDesc && <p style={{ color: '#EF4444', fontSize: '0.8rem', margin: '0.25rem 0 0' }}>{plErrors.productLineDesc}</p>}
                            </div>
                            <div className="col-6">
                                <label className={styles.formLabel}>Markup % <span className={styles.requiredIndicator}>*</span></label>
                                <div className={styles.formInputGroup}>
                                    <input
                                        type="number" min="0" step="0.01"
                                        className={styles.formInput}
                                        style={plErrors.markup ? { borderColor: '#EF4444' } : {}}
                                        value={plForm.markup}
                                        onChange={e => this.onPLField('markup', e.target.value)}
                                        placeholder="0.00"
                                    />
                                    <span className={styles.inputUnit}>%</span>
                                </div>
                                {plErrors.markup && <p style={{ color: '#EF4444', fontSize: '0.8rem', margin: '0.25rem 0 0' }}>{plErrors.markup}</p>}
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.5rem', justifyContent: 'flex-end' }}>
                            <button onClick={this.closePLModal} style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '0.6rem 1.25rem', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                <BsXCircle /> Cancel
                            </button>
                            <button onClick={this.submitPL} disabled={plSaving} className={styles.btnSaveCustom} style={{ border: 'none' }}>
                                <BsPlusCircle /> {plSaving ? 'Creating…' : 'Create Product Line'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderVendorModal() {
        const { showVendorModal, vendorForm, vendorErrors, vendorSaving } = this.state;
        if (!showVendorModal) return null;
        return (
            <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 }}>
                <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '560px', margin: '1rem', boxShadow: '0 20px 60px rgba(0,0,0,0.2)', maxHeight: '90vh', overflowY: 'auto' }}>
                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', borderRadius: '16px 16px 0 0', padding: '1.5rem 2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 1 }}>
                        <div>
                            <div style={{ color: 'white', fontFamily: "'Archivo', sans-serif", fontWeight: 700, fontSize: '1.125rem' }}>Create New Vendor</div>
                            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem', marginTop: '0.25rem' }}>Vendor No is assigned by the system</div>
                        </div>
                        <button onClick={this.closeVendorModal} style={{ background: 'none', border: 'none', color: 'white', fontSize: '1.25rem', cursor: 'pointer' }}><BsXCircle /></button>
                    </div>
                    <div style={{ padding: '1.5rem 2rem' }}>
                        <div className="row g-3">
                            <div className="col-12">
                                <label className={styles.formLabel}>Vendor No (system)</label>
                                <input className={styles.formInput} value={vendorForm.VendorNo || ''} disabled style={{ background: '#F1F5F9', color: '#64748B' }} placeholder="Assigned by the system" />
                            </div>
                            {VENDOR_FIELDS.map(f => (
                                <div key={f.id} className={f.col}>
                                    <label className={styles.formLabel}>{f.label} <span className={styles.requiredIndicator}>*</span></label>
                                    <input
                                        id={f.id}
                                        type={f.type || 'text'}
                                        inputMode={f.kind === 'phone' ? 'tel' : undefined}
                                        placeholder={f.placeholder}
                                        className={styles.formInput}
                                        style={vendorErrors[f.id] ? { borderColor: '#EF4444' } : {}}
                                        value={vendorForm[f.id] || ''}
                                        onChange={e => this.onVendorField(f.id, f.kind === 'phone' ? formatPhone(e.target.value) : e.target.value)}
                                    />
                                    {vendorErrors[f.id] && <p style={{ color: '#EF4444', fontSize: '0.8rem', margin: '0.25rem 0 0' }}>{vendorErrors[f.id]}</p>}
                                </div>
                            ))}
                        </div>
                        <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.5rem', justifyContent: 'flex-end' }}>
                            <button onClick={this.closeVendorModal} style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '0.6rem 1.25rem', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                <BsXCircle /> Cancel
                            </button>
                            <button onClick={this.submitVendor} disabled={vendorSaving} className={styles.btnSaveCustom} style={{ border: 'none' }}>
                                <BsPlusCircle /> {vendorSaving ? 'Creating…' : 'Create Vendor'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { step } = this.state;
        return (
            <div className="dash-page container-fluid pb-5">
                <Menu Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                <div className="container-fluid" style={{ paddingTop: '1.5rem' }}>

                    {/* Hero */}
                    <div style={{
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)',
                        borderRadius: '16px', padding: '2rem 2.5rem',
                        marginBottom: '2rem', marginTop: '2rem',
                        color: 'white', display: 'flex', alignItems: 'center',
                        justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem',
                    }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                                <MdPhotoCamera style={{ fontSize: '1.75rem', opacity: 0.9 }} />
                                <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: '1.75rem', margin: 0 }}>
                                    Add New Product
                                </h2>
                            </div>
                            <p style={{ margin: 0, opacity: 0.8, fontSize: '0.9375rem' }}>
                                Step {step} of 3 ·{' '}
                                {step === 1 ? 'Choose product line' : step === 2 ? 'Choose vendor' : 'Fill product details'}
                                {' '}· {getValueCookie('Company')}
                            </p>
                        </div>
                        <a
                            href="/inventory/products"
                            style={{
                                background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)',
                                borderRadius: '10px', color: 'white', textDecoration: 'none',
                                padding: '0.6rem 1.25rem', fontSize: '0.875rem', fontWeight: 600,
                                display: 'flex', alignItems: 'center', gap: '0.4rem',
                            }}
                        >
                            <RiArrowGoBackFill /> Back to Products
                        </a>
                    </div>

                    {/* Stepper */}
                    {this.renderStepper()}

                    {/* Step content */}
                    {step === 1 && this.renderStep1()}
                    {step === 2 && this.renderStep2()}
                    {step === 3 && this.renderStep3()}

                </div>

                {/* Modals */}
                {this.renderPLModal()}
                {this.renderVendorModal()}
            </div>
        );
    }
}
